import { useMemo } from 'react';

export default function CarouselSection() {
  const items = useMemo(() => [
    {
      id: 1,
      title: '年度吃瓜大事件全景回顾',
      desc: '从娱乐圈巨震到社会热点，2026上半年最值得铭记的吃瓜名场面全收录',
      image: 'https://readdy.ai/api/search-image?query=Panoramic%20abstract%20digital%20collage%20of%20breaking%20news%20visuals%20in%20warm%20red%20and%20amber%20tones%2C%20representing%20yearly%20highlights%2C%20mysterious%20dark%20background%2C%20cinematic%20composition%2C%20no%20text%20no%20faces&width=700&height=420&seq=carousel-01&orientation=landscape',
      tag: '年度精选',
      stat: '12个名场面',
    },
    {
      id: 2,
      title: '暗网吃瓜直播 · 王牌栏目',
      desc: '每日深夜直播追踪最热话题，主持人实时解读，弹幕互动火热',
      image: 'https://readdy.ai/api/search-image?query=Live%20broadcast%20studio%20concept%20with%20glowing%20red%20ring%20light%20and%20abstract%20audience%20data%20waves%2C%20dark%20atmosphere%2C%20representing%20streaming%20show%2C%20professional%20broadcast%20style%2C%20no%20text%20no%20faces&width=700&height=420&seq=carousel-02&orientation=landscape',
      tag: '王牌栏目',
      stat: '每晚22:00',
    },
    {
      id: 3,
      title: '51cg吃瓜 · 经典合集',
      desc: '51cg吃瓜频道最受欢迎的视频合集，一次看过瘾，吃瓜不停歇',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20collection%20of%20video%20thumbnails%20forming%20a%20mosaic%20pattern%20in%20warm%20crimson%20and%20gold%20colors%2C%20dark%20background%2C%20representing%20content%20library%2C%20organized%20grid%20style%2C%20no%20text%20no%20faces&width=700&height=420&seq=carousel-03&orientation=landscape',
      tag: '经典合集',
      stat: '50+视频',
    },
    {
      id: 4,
      title: '在线暗网吃瓜 · 安全指南',
      desc: '了解如何安全地享受吃瓜体验，匿名浏览技巧与隐私保护全攻略',
      image: 'https://readdy.ai/api/search-image?query=Abstract%20shield%20symbol%20surrounded%20by%20encrypted%20data%20layers%20in%20amber%20and%20warm%20red%20tones%2C%20representing%20digital%20safety%20and%20privacy%20protection%2C%20dark%20background%2C%20minimalist%20tech%20style%2C%20no%20text%20no%20faces&width=700&height=420&seq=carousel-04&orientation=landscape',
      tag: '使用指南',
      stat: '必读推荐',
    },
  ], []);

  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 mt-3">精选专题内容，深度吃瓜体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {items.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 group cursor-pointer hover:border-primary-300 transition-all duration-200"
            >
              <div className="relative overflow-hidden aspect-[5/3]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold font-heading text-foreground-800 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 mt-2 leading-relaxed">{item.desc}</p>
                <div className="flex items-center gap-2 mt-4 pt-3 border-t border-background-200/70">
                  <span className="text-xs text-foreground-400">{item.stat}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}